import React from 'react';

import { createServiceHeaderLayoutClassName } from './serviceHeaderLayoutStyles';
import { ServicePageNavigationRoot } from 'design/servicePageNavigationPortalComponents';

type Props = {
  size?: 'auto';
  logo: React.ReactNode;
  accountControls?: React.ReactNode;
};

export const ServiceHeaderLayoutComponent = (props: Props) => {
  const { size = 'auto', logo, accountControls } = props;

  const headerClassName = createServiceHeaderLayoutClassName('header');

  const headerContentClassName = createServiceHeaderLayoutClassName(
    'headerContent',
    { size }
  );

  const logoClassName = createServiceHeaderLayoutClassName('logo');

  const accountControlsClassName = createServiceHeaderLayoutClassName(
    'accountControls'
  );

  const navigationControlsClassName = createServiceHeaderLayoutClassName(
    'navigationControls'
  );

  return (
    <header className={headerClassName}>
      <div className={headerContentClassName}>
        <div className={navigationControlsClassName}>
          <ServicePageNavigationRoot />
        </div>
        <div className={logoClassName}>{logo}</div>
        <div className={accountControlsClassName}>{accountControls}</div>
      </div>
    </header>
  );
};
